import { FC } from 'react';
import DownloadIcon from '@mui/icons-material/Download';

import { IconButtonRounded } from '../..';
import { CircularLoader } from '../../../shared';

interface Props {
    title: string;
    disabled: boolean;
    isLoading: boolean;
    testId: string;
    onClick: () => void;
}

export const NgDownloadButton: FC<Props> = ({ disabled, isLoading, title, testId, onClick }) => {

  return (
    <div
      style={{
        opacity: disabled ? 0.3 : 1,
      }}
    >
      <IconButtonRounded
        title={title}
        icon={isLoading ? <CircularLoader size={20} /> : <DownloadIcon />}
        onClick={onClick}
        disabled={disabled}
        testId={testId}
      />
    </div>
  );
};
